import React from 'react'
import { usePodcastEditor } from '../../context/use-podcast-editor'
import { VoiceSelect } from '../voice-select/voice-select'
import { useConfirm } from '../../../../context/confirm-context'

export const VoiceSelectorForPodcast: React.FC = () => {
  const { podcast, hostAVoiceId, hostBVoiceId, setHostAVoiceId, setHostBVoiceId, voices, isLoading } = usePodcastEditor()
  const { confirm } = useConfirm()
  const isVoicesLoading = isLoading || voices.length === 0

  // Detect if any line already has generated audio
  const hasAnyGeneratedAudio = React.useMemo(() => {
    const lines = podcast?.podcastLines || []
    return lines.some(l => !!l.audioFileUrl && l.audioFileUrl.trim().length > 0)
  }, [podcast])

  const confirmIfNeeded = React.useCallback(async (): Promise<boolean> => {
    if (!hasAnyGeneratedAudio) return true
    return await confirm({
      title: 'Change host voice?',
      description: 'Changing a host\'s voice will delete any audio you\'ve already generated for that host. You\'ll need to regenerate the audio, which will use additional credits.',
      confirmText: 'Change voice',
      cancelText: 'Keep current voice',
      variant: 'default'
    })
  }, [hasAnyGeneratedAudio, confirm])

  const handleChangeA = React.useCallback(async (id: string) => {
    if (!(await confirmIfNeeded())) return
    await setHostAVoiceId(id)
  }, [confirmIfNeeded, setHostAVoiceId])

  const handleChangeB = React.useCallback(async (id: string) => {
    if (!(await confirmIfNeeded())) return
    await setHostBVoiceId(id)
  }, [confirmIfNeeded, setHostBVoiceId])

  return (
    <div className="space-y-5" data-tourid="voice-selection-container">
      <VoiceSelect
        label="Host A voice"
        value={hostAVoiceId}
        onChange={(id) => { void handleChangeA(id) }}
        options={voices}
        loading={isVoicesLoading}
      />
      <div className="h-px bg-black/10" />
      <VoiceSelect
        label="Host B voice"
        value={hostBVoiceId}
        onChange={(id) => { void handleChangeB(id) }}
        options={voices}
        loading={isVoicesLoading}
      />
    </div>
  )
}
